<template lang="pug">
.fraud-reports-page
  .fraud-reports-header
    .title-section Informes antifraude
    shActionButton(
      v-if="canRun"
      :action="runReport"
      text="Verificar ahora"
      textRunning="Analizando órdenes..."
      :disabled="isRunning"
      width="12rem"
    )
  shListData(title="" resolver="fraudReports" keyData="_id" component="shFraudReport")
</template>

<script>
import shListData from '@/components/global/ListData'
import shActionButton from '@/components/elements/ActionButton'
import gql from '@my/graphql'
import gqlFraudReport from '@/graphql/fraudReport'

export default {
  name: 'FraudReports',

  components: { shListData, shActionButton },

  data () {
    return {
      isRunning: false
    }
  },

  computed: {
    canRun () {
      try {
        const permissions = JSON.parse(this.$store.state.variables.permissionsString)
        const userPermissions = permissions[this.$store.state.user.type]
        return userPermissions &&
          userPermissions.permissions.fraudCase &&
          userPermissions.permissions.fraudCase.update
      } catch (error) {
        return false
      }
    }
  },

  methods: {
    async runReport () {
      if (this.isRunning) return
      this.isRunning = true
      try {
        const response = await gql.mutate(gqlFraudReport.RUN)
        const report = response && response.data && response.data.runFraudReport
        if (!report) {
          alert('No se pudo iniciar el análisis')
          return
        }
        this.$store.commit('getData', { resolver: 'fraudReports', page: 1, key: '_id' })
      } catch (error) {
        console.log(error)
        alert((error && error.message) || 'Error al iniciar el análisis')
      } finally {
        this.isRunning = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.fraud-reports-page
  .fraud-reports-header
    display flex
    align-items center
    justify-content space-between
    margin-bottom 1rem
    padding 0 0.5rem

    .title-section
      font-size 1.1rem
      font-weight 600
</style>



// WEBPACK FOOTER //
// src/components/pages/fraudReport/FraudReports.vue